(function () {
  const T = window.Tedeman || {};
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));
  const money = (cents) => new Intl.NumberFormat(T.locale === "en" ? "en-GB" : "de-DE", { style: "currency", currency: T.currency || "EUR" }).format(cents / 100);
  const esc = (s) => String(s).replace(/[&<>"]/g, (c) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[c]));
  const shortTitle = (t) => t.replace(/^Tedeman\s+/i, "").split(/\s[–—-]\s|,\s|\s\(/)[0];

  /* ---------- cart drawer (Shopify AJAX cart API) ---------- */
  const drawer = $("[data-cart-drawer]");
  const openCart = () => document.body.classList.add("cart-open");
  const closeCart = () => document.body.classList.remove("cart-open");

  function renderCart(cart) {
    if (!drawer) return;
    const box = $("[data-cart-items]", drawer);
    box.innerHTML = cart.items.length ? cart.items.map((item) => `
      <div class="ditem">
        ${item.image ? `<img src="${item.image}${item.image.includes("?") ? "&" : "?"}width=160" alt="" width="68" height="68" loading="lazy">` : "<span></span>"}
        <div><b>${esc(shortTitle(item.product_title))}</b><span>${item.product_has_only_default_variant ? "" : esc(item.variant_title) + " · "}${esc(T.strings.quantity)} ${item.quantity}</span></div>
        <div style="text-align:right">${money(item.final_line_price)}<br><button type="button" data-remove="${item.key}" class="link-rm">${esc(T.strings.remove)}</button></div>
      </div>`).join("") : `<p class="empty">${esc(T.strings.empty)}</p>`;
    $("[data-cart-total]", drawer).textContent = money(cart.total_price);
    const note = $("[data-ship-note]", drawer);
    if (note) {
      const left = (T.freeShipping || 0) - cart.total_price;
      note.textContent = !cart.items.length || !T.freeShipping ? "" : left <= 0 ? T.strings.freeShippingReached : T.strings.freeShippingRemaining.replace("{{ amount }}", money(left));
    }
    $$("[data-cart-count]").forEach((el) => (el.textContent = cart.item_count));
    $$("[data-remove]", box).forEach((b) => (b.onclick = () => changeLine(b.dataset.remove, 0)));
  }

  const fetchCart = () => fetch(T.routes.cart, { headers: { Accept: "application/json" } }).then((r) => r.json());
  function changeLine(key, quantity) {
    return fetch(T.routes.cartChange, { method: "POST", headers: { "Content-Type": "application/json", Accept: "application/json" }, body: JSON.stringify({ id: key, quantity }) })
      .then((r) => r.json()).then(renderCart);
  }

  $$("[data-cart-open]").forEach((a) => a.addEventListener("click", (e) => {
    if (!drawer) return;
    e.preventDefault();
    fetchCart().then(renderCart).finally(openCart);
  }));
  $$("[data-cart-close]").forEach((b) => b.addEventListener("click", closeCart));
  document.addEventListener("keydown", (e) => { if (e.key === "Escape") closeCart(); });
  if (drawer) fetchCart().then(renderCart).catch(() => {});

  /* ---------- product page ---------- */
  const root = $("[data-product]");
  if (root) {
    const data = JSON.parse($("[data-product-json]", root).textContent);
    const form = $("[data-product-form]", root);
    const stage = $("[data-stage]", root);
    const idInput = $("[data-variant-id]", root);
    const addBtn = $("[data-add]", root);
    const err = $("[data-form-error]", root);

    /* gallery: thumbnails on desktop, arrows / swipe / dots on phones */
    const pics = $$(".thumbs img", root).map((t) => t.dataset.full);
    const dots = $("[data-gdots]", root);
    // dots for a few photos, a "3 / 36" counter for many
    const counter = pics.length > 10;
    if (dots) dots.innerHTML = counter ? "" : pics.map(() => "<span></span>").join("");
    const show = (src) => {
      if (!stage || !src) return;
      stage.src = src;
      $$(".thumbs img", root).forEach((t) => t.classList.toggle("on", t.dataset.full === src));
      if (dots && counter) dots.textContent = `${Math.max(0, pics.indexOf(src)) + 1} / ${pics.length}`;
      else if (dots) $$("span", dots).forEach((d, i) => d.classList.toggle("on", pics[i] === src));
    };
    const step = (dir) => {
      if (!pics.length) return;
      const i = pics.indexOf(stage.src);
      show(pics[((i < 0 ? 0 : i) + dir + pics.length) % pics.length]);
    };
    $$(".thumbs img", root).forEach((t) => (t.onclick = () => show(t.dataset.full)));
    $$("[data-gnav]", root).forEach((b) => (b.onclick = () => step(parseInt(b.dataset.gnav, 10))));
    if (stage) {
      let x0 = null;
      stage.parentNode.addEventListener("touchstart", (e) => { x0 = e.touches[0].clientX; }, { passive: true });
      stage.parentNode.addEventListener("touchend", (e) => {
        if (x0 === null) return;
        const dx = e.changedTouches[0].clientX - x0;
        x0 = null;
        if (Math.abs(dx) > 40) step(dx < 0 ? 1 : -1);
      });
      show(stage.src);
    }

    /* colour bottom sheet (phones, many colours) */
    const sheet = $("[data-csheet].as-sheet", root);
    const openSheet = () => { if (sheet) { sheet.classList.add("open"); document.body.classList.add("sheet-open"); const on = $(".colours .on", sheet); if (on) on.scrollIntoView({ block: "center" }); } };
    const closeSheet = () => { if (sheet) { sheet.classList.remove("open"); document.body.classList.remove("sheet-open"); } };
    $$("[data-sheet-close]", root).forEach((b) => (b.onclick = closeSheet));
    document.addEventListener("keydown", (e) => { if (e.key === "Escape") closeSheet(); });

    /* preview row: selected colour first, then the next two, then "+N" */
    const peek = $("[data-peek]", root);
    const renderPeek = (cur) => {
      if (!peek) return;
      const list = data.variants.filter((v) => v.swatch);
      const start = Math.max(0, list.findIndex((v) => v.id === cur));
      const pick = [0, 1, 2].map((k) => list[(start + k) % list.length]);
      const rest = list.length - 3;
      const next = list[(start + 3) % list.length];
      peek.innerHTML = pick.map((v) => `<button type="button" data-pv="${v.id}" class="${v.id === cur ? "on" : ""}" aria-label="${esc(v.title)}"><i style="background-image:url('${v.swatch}')"></i><span class="nm">${esc(v.title)}</span></button>`).join("")
        + `<button type="button" class="more" data-more aria-label="+${rest}"><i data-n="+${rest}" style="background-image:url('${next.swatch}')"></i></button>`;
      $$("[data-pv]", peek).forEach((b) => (b.onclick = () => select(b.dataset.pv)));
      $("[data-more]", peek).onclick = openSheet;
    };

    const select = (id) => {
      const v = data.variants.find((x) => String(x.id) === String(id));
      if (!v) return;
      $$("[data-v]", root).forEach((x) => { const on = x.dataset.v === String(v.id); x.classList.toggle("on", on); x.setAttribute("aria-checked", on ? "true" : "false"); });
      idInput.value = v.id;
      $$("[data-variant-name]", root).forEach((n) => (n.textContent = v.title));
      $("[data-price]", root).innerHTML = v.priceHtml;
      const sp = $("[data-sticky-price]", root);
      if (sp) sp.innerHTML = v.priceHtml;
      const stock = $("[data-stock]", root);
      if (stock) { stock.textContent = v.available ? stock.dataset.in : stock.dataset.out; stock.classList.toggle("out", !v.available); }
      addBtn.disabled = !v.available;
      addBtn.textContent = v.available ? (data.isPattern ? addBtn.textContent : T.strings.addToCart) : T.strings.soldOut;
      const sb = $("[data-sticky-add]", root);
      if (sb) { sb.disabled = addBtn.disabled; sb.textContent = addBtn.textContent; }
      if (v.image) show(v.image);
      renderPeek(v.id);
      const url = new URL(location.href);
      url.searchParams.set("variant", v.id);
      history.replaceState({}, "", url);
    };
    $$("[data-v]", root).forEach((b) => (b.onclick = () => { select(b.dataset.v); closeSheet(); }));
    renderPeek(Number(idInput.value));

    /* sticky add-to-cart bar on phones */
    const bar = $("[data-sticky-buy]", root);
    if (bar && "IntersectionObserver" in window) {
      new IntersectionObserver(([e]) => bar.classList.toggle("show", !e.isIntersecting && e.boundingClientRect.top < 0)).observe(addBtn);
      $("[data-sticky-add]", bar).onclick = () => form.requestSubmit ? form.requestSubmit(addBtn) : addBtn.click();
    }

    const qty = $("[data-qty-input]", root);
    $$("[data-qty]", root).forEach((b) => (b.onclick = () => {
      qty.value = Math.max(1, (parseInt(qty.value, 10) || 1) + parseInt(b.dataset.qty, 10));
    }));

    if (form && drawer) {
      form.addEventListener("submit", (e) => {
        e.preventDefault();
        err.hidden = true;
        addBtn.disabled = true;
        fetch(T.routes.cartAdd, { method: "POST", headers: { Accept: "application/json" }, body: new FormData(form) })
          .then((r) => r.json().then((body) => ({ ok: r.ok, body })))
          .then(({ ok, body }) => {
            if (!ok) throw new Error(body.description || body.message || T.strings.error);
            return fetchCart().then(renderCart).then(openCart);
          })
          .catch((e2) => { err.textContent = e2.message || T.strings.error; err.hidden = false; })
          .finally(() => { addBtn.disabled = false; });
      });
    }
  }

  /* ---------- free pattern download: ask for name + e-mail once per browser ---------- */
  const lead = $("[data-lead]");
  if (lead) {
    const KEY = "tedeman_pattern_lead";
    const done = $("[data-lead-done]", lead);
    const leadForm = $("[data-lead-form]", lead);
    let known = false;
    try { known = localStorage.getItem(KEY) === "1"; } catch (e) {}
    if (!done.hidden) {
      // just signed up (server confirmed the customer form)
      try { localStorage.setItem(KEY, "1"); } catch (e) {}
      if (leadForm) leadForm.hidden = true;
      if (/customer_posted=true/.test(location.search)) lead.scrollIntoView({ block: "center" });
    } else if (known) {
      done.hidden = false;
      if (leadForm) leadForm.hidden = true;
    }
  }

  /* ---------- carousels ---------- */
  $$("[data-carousel]").forEach((c) => {
    const t = $(".track", c);
    $(".l", c).onclick = () => t.scrollBy({ left: -t.clientWidth, behavior: "smooth" });
    $(".r", c).onclick = () => t.scrollBy({ left: t.clientWidth, behavior: "smooth" });
  });

  /* ---------- customer login: toggle password recovery ---------- */
  const rec = $("#recover");
  if (rec && location.hash !== "#recover") rec.hidden = true;
  $$("[data-toggle-recover]").forEach((a) => (a.onclick = (e) => { e.preventDefault(); rec.hidden = !rec.hidden; }));
})();
